import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
interface button {
  onClick: any;
  disabled: any;
  isLoading: any;
}
const AddEditButton = ({ onClick, disabled, isLoading: isSaving }: button) => {
  const isEdit = () => {
    return !!id;
  };
  const [t] = useTranslation("common");
  const { id } = useParams();
  return (
    <Button
      disabled={disabled}
      style={{
        background: "#1677FF",
        color: "#fff",
        height: "40px",
        border: "none",
      }}
      className="btn"
      size="large"
      onClick={onClick}
    >
      {!isSaving && (isEdit() ? `${t("save")}` : `${t("add")}`)}
      {isSaving && "Loading..."}
    </Button>
  );
};
export default AddEditButton;
